import { filter, firstValueFrom } from 'rxjs';
import { UserContextProvider } from '../context/user-context-provider';

export const waitForAccount = async (userContextProvider: UserContextProvider): Promise<void> => {
  if (userContextProvider.account) {
    return;
  }

  await firstValueFrom(userContextProvider.account$.pipe(filter(account => !!account)));
};
